export default "__VITE_ASSET__97cb8d28__"